import {
  FDDisplayText, FDHeadlineText, FDImage, FDLozenge, FDStack,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import {
  DataCardWithTruncation,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/Common/DataCardWithTruncation';


const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride(['dataValueString'], {
    _component: () => FDDisplayText,
    _customProps: { size: 'sm', color: 'textSecondary' },
  }, overrideReadOnly);

export const PersonalizedOutcomeDataCard = ({ resource }) => {
  return (
    <DataCardWithTruncation cardContent={resource.attr('dataDescription')} cardTitle={resource.attr('title')} test="personalized-outcome-data-card">
      <FDStack alignItems={'flex-start'} justifyContent={'space-between'} spacing={1}>
        <MetaControl resource={resource} attrName={'title'} metaOverrideSet={metaOverrides} flex={1} />
        {resource.withRelationship(fr.relationships.image.name,
          (rel) => <FDImage alt={''} width={32} height={32} src={rel.link('related').url()} rounded={false} />,
          () => null)}
      </FDStack>
      <FDStack direction={'row'} spacing={1} wrap>
        {resource.attr('infoSnippets')?.resources().list().map((is) => (<FDLozenge key={is.id()} label={is.attr('name')} color={is.attr('status')} />))}
      </FDStack>
      <MetaControl resource={resource} attrName={'dataValueString'} metaOverrideSet={metaOverrides} />
      <MetaControl resource={resource} attrName={'dataDescription'} metaOverrideSet={metaOverrides} />
    </DataCardWithTruncation>
  );
};

PersonalizedOutcomeDataCard.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
